/**
 * Статус прескоринга лимита для заемщика
 */
export enum BorrowerLimitPrescoringStatusType {
    NONE = 'none',
    UPDATING = 'updating',
    APPROVE = 'approve',
    REJECT = 'reject',
    ERROR = 'error',
}

/**
 * Модель данных статуса прескоринга лимита для заемщика
 */
export interface BorrowerLimitPrescoringStatus {
    /**
     * Текущий статус прескоринга
     */
    scoring_status: BorrowerLimitPrescoringStatusType;
    /**
     * Ссылка на визард с данными прескоринга
     */
    redirect_url?: string;
    /**
     * Максимальный лимит
     */
    limit_amount?: number;
    /**
     * Срок в месяцах
     */
    term_months?: number;
    /**
     * Ставка в процентах
     */
    rate?: number;
    /**
     * Дата следующего возможного скоринга в случае отказа в формате ISO
     */
    next_scoring_date?: string;
}

/**
 * Ответ на запрос прескоринга лимита
 */
export interface BorrowerLimitPrescoringRequest {
    /**
     * Флаг наличия заемщика на платформе
     */
    has_account: boolean;
}

/**
 * Контакты заемщика при запросе прескоринга лимита
 */
export interface BorrowerLimitPrescoringContacts extends BorrowerLimitPrescoringInitialData {
    /**
     * Номер телефона
     */
    phone?: string;
    /**
     * Email
     */
    email?: string;
}

export interface BorrowerLimitPrescoringInitialData {
    /**
     * ИНН
     */
    inn: string;
    /**
     * Данные компании в формате JSON
     */
    company_data?: string;
}

/**
 * Данные прескоринга лимита
 */
export interface BorrowerLimitPrescoringStoreData extends BorrowerLimitPrescoringStatus,  BorrowerLimitPrescoringInitialData, BorrowerLimitPrescoringModalData {
    /**
     * Текст ошибки
     */
    error?: string;
    /**
     * Флаг сокрытия лоадера
     */
    hideLoader?: boolean;
    /**
     * Флаг наличия контактов
     */
    hasContacts?: boolean;
    /**
     * Флаг готового скоринга
     */
    isReady?: boolean;
}

export enum BorrowerLimitPrescoringModalStage {
    /**
     * Есть аккаунт
     */
    HAS_ACCOUNT = 'has_account',
    /**
     * Скоринг в процессе
     */
    PROCESS = 'process',
    /**
     * Подтверждение email
     */
    EMAIL_CONFIRM = 'email_confirm',
    /**
     * Подтверждение телефона
     */
    PHONE_CONFIRM = 'phone_confirm',
    /**
     * Подтверждение кода
     */
    CODE_CONFIRM = 'code_confirm',
    /**
     * Успешный скоринг
     */
    APPROVE = 'approve',
    /**
     * Отказ при скоринге
     */
    REJECT = 'reject',
}

export interface BorrowerLimitPrescoringModalData {
    /**
     * Стадия модального окна прескоринга
     */
    stage: BorrowerLimitPrescoringModalStage;
}